import { useMemo, useState } from 'react';
import { ModalContext, ModalContextValues } from '@hooks/useModalControl';
import AddWrestlerModal, { TEAM_MEMBER_MODAL } from '@components/AddWrestler/AddWrestlerModal';
import CreateTeamModal from '@components/teamCreation/CreateTeamModal';
import CreateEventModal from '@components/eventCreation/CreateEventModal';
import ImportModal from '@components/teamCreation/ImportModal';
import TeamImportModal from '@components/teamCreation/TeamImportModal';

export default function ModalProvider({ children }: { children: JSX.Element }): React.JSX.Element {
    const [showEventModal, setShowEventModal] =
        useState<ModalContextValues['showEventModal']>(false);
    const [showTeamModal, setShowTeamModal] = useState<boolean | string>(false);
    const [showAddChildModal, setShowAddChildModal] = useState<boolean | string>(false);
    const [showAddTeamMember, setShowAddTeamMember] = useState<boolean | string>(false);
    const [showImportModal, setShowImportModal] = useState<boolean>(false);
    const [showTeamImportModal, setShowTeamImportModal] = useState<boolean>(false);

    const modalContext: ModalContextValues = useMemo(() => {
        return {
            showEventModal,
            setShowEventModal,
            setShowTeamModal,
            setShowAddChildModal,
            setShowAddTeamMember,
            setShowImportModal,
            setShowTeamImportModal,
        };
    }, [showEventModal]);

    return (
        <ModalContext.Provider value={modalContext}>
            {
                <>
                    {children}
                    {/* Unmount when not showing to clear form state */}
                    {showEventModal ? (
                        <CreateEventModal
                            onClose={() => setShowEventModal(false)}
                            showModal={!!showEventModal}
                        />
                    ) : null}
                    {/* Unmount when not showing to clear form state */}
                    {showTeamModal ? (
                        <CreateTeamModal
                            onClose={() => setShowTeamModal(false)}
                            showModal={!!showTeamModal}
                        />
                    ) : null}
                    {/* Unmount when not showing to clear form state */}
                    {showAddChildModal ? <AddWrestlerModal type="child" /> : null}
                    {showAddTeamMember ? <AddWrestlerModal type={TEAM_MEMBER_MODAL} /> : null}
                    {showImportModal ? (
                        <ImportModal onClose={() => setShowImportModal(false)} />
                    ) : null}
                    {showTeamImportModal ? (
                        <TeamImportModal onClose={() => setShowTeamImportModal(false)} />
                    ) : null}
                </>
            }
        </ModalContext.Provider>
    );
}
